import {
  FC,
  Children,
  ReactElement,
  isValidElement,
  cloneElement,
  HTMLAttributes
} from 'react'
import { css } from '@emotion/react'
import { TabProps } from './Tab'

const styles = {
  root: css({
    display: 'flex'
  })
}

export interface TabsProps extends HTMLAttributes<HTMLDivElement> {
  value: number
  handleTab: Required<TabProps>['onClick']
}

export const Tabs: FC<TabsProps> = (props) => {
  const { children, handleTab, value, ...rest } = props
  const newChildren = Children.toArray(children)
    .filter<ReactElement<Partial<TabProps>>>(isValidElement)
    .map((child, index) =>
      cloneElement(child, {
        onClick: handleTab,
        index: index,
        selected: value === index
      })
    )
  return (
    <div css={styles.root} role="tablist" {...rest}>
      {newChildren}
    </div>
  )
}
